import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: function () { 
          return import('./views/Home.vue')
      }
    },
    {
      path: '/sobre-mi',
      name: 'about-me',
      component: function () { 
        return import('./views/AboutMe.vue')
      }
    },
    {
      path: '/trabajos',
      name: 'works',
      component: function () { 
        return import('./views/Works.vue')
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
